import request from '../utils/request'

export function getAutomationResources(apiUrl: string) {
  return request.get(apiUrl)
}
